import { } from 'react';
import { useLocalStorage } from '../../utils/useLocalStorage';
import { GridIcon } from '../icons/grid.icon';
import { ListIcon } from '../icons/list.icon';

import { DriveItem } from './drive_item.types';
import { DriveListView } from './drive_list_view.component';
import { FolderCard } from './folder_card.component';
import { FileCard } from './file_card.component';
import { useTranslation } from 'react-i18next';


type ViewMode = 'grid' | 'list';

interface DriveExplorerProps {
  items: DriveItem[];
  searchQuery?: string;
  onSearchChange?: ( v: string ) => void;
  onDeleteSelected?: ( ids: string[] ) => Promise<void> | void;
}

export function DriveExplorer( props: DriveExplorerProps ) {
  const { t } = useTranslation();
  const { items } = props;

  const [ view, setView ] = useLocalStorage<ViewMode>( 'driveExplorer.viewMode', 'grid' );

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex items-center justify-end gap-3">
        <div className="flex rounded-lg border border-gray-200 overflow-hidden">
          <button
            type="button"
            className={ `flex items-center justify-center w-10 h-10 transition-colors ${ view === 'grid' ? 'bg-red-50' : 'bg-white hover:bg-gray-50' }` }
            onClick={ () => { setView( 'grid' ); localStorage.setItem( 'drive_view_mode', 'grid' ); } }
            title={ t( 'translation:grid_view' ) }
          >
            <GridIcon active={ view === 'grid' } />
          </button>
          <button
            type="button"
            className={ `flex items-center justify-center w-10 h-10 border-l border-gray-200 transition-colors ${ view === 'list' ? 'bg-red-50' : 'bg-white hover:bg-gray-50' }` }
            onClick={ () => { setView( 'list' ); localStorage.setItem( 'drive_view_mode', 'list' ); } }
            title={ t( 'translation:list_view' ) }
          >
            <ListIcon active={ view === 'list' } />
          </button>
        </div>

        <div className="w-56">
          <input
            type="text"
            value={ props.searchQuery ?? '' }
            onChange={ e => {return props.onSearchChange?.( e.target.value );} }
            placeholder={ t( 'translation:Search' ) }
            className="w-full p-2 border rounded-md"
          />
        </div>
      </div>

      {/* Content */}
      { view === 'list' && (
        <DriveListView items={ items } onDeleteSelected={ props.onDeleteSelected } />
      ) }

      { view === 'grid' && (
        <div className="flex flex-wrap gap-4">
          { items.map( item => {
            return (
              <div key={ item.id }>
                {
                  item.type === 'folder'
                    ? (
                      <FolderCard
                        name={ item.name }
                        elementCount={ item.size }
                        lastModified={ item.lastModified }
                        actions={ item.actions }
                        onClick={ item.onClick }
                      />
                    )
                    : (
                      <FileCard
                        name={ item.name + ( item.extension ?? '' ) }
                        extension={ item.extension ?? '' }
                        sizeBytes={ item.size }
                        lastModified={ item.lastModified }
                        actions={ item.actions }
                        onClick={ item.onClick }
                      />
                    )
                }
              </div>
            );
          } ) }
        </div>
      ) }
    </div>
  );
}
